import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { GenericService } from '../../../infrastructure/infrastructure-services/services/base/generic-service';
import { GenericEntryForm } from '../../../infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { ActivatedRoute, Router } from '@angular/router';
import { enumBPMaster, enumErrorMessageText, enumFormModes, enumObjectType } from '../../../infrastructure/infrastructure-services/common/common-enums';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { MatRadioChange } from '@angular/material/radio';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { Attachments2_LinesModel, BPAddressesModel, BPAddressesModelSAP, BPBankAccountsModel, BPBranchAssignmentModel, BPContactEmployeesModel, BPFiscalTaxIDCollectionModel, BPMasterModel, BPMasterModelSAP, BPWithholdingTaxCollectionModel, IBPMasterModel, IBPMasterModelSAP } from 'src/app/core/models/masters/bp-master.model';
import { WrapperStandardFilter, WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';

import { NgxIndexedDBService } from 'ngx-indexed-db';
import { GenericAttachmentUploadView } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-view';
import { HttpClient } from '@angular/common/http';
import { AddAddressComponent } from './add-address/add-address.component';
import { createMap, forMember, mapFrom } from '@automapper/core';
import { GlobalProperties } from 'src/app/global/global-properties';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { SecurityService } from 'src/app/login-layout/Service/security.service';
//import { AddAddressComponent } from './add-address/add-address.component';


@Component({
  selector: 'app-business-partner-master-entryform',
  templateUrl: './business-partner-master-entryform.component.html',
  styleUrls: ['./business-partner-master-entryform.component.css']
})
export class BusinessPartnerMasterEntryformComponent extends GenericEntryForm<IBPMasterModel, IBPMasterModelSAP> {
  [x: string]: any;
  displayedColumns: any[] = [];
  displayedColumnAddressBillTo: any[] = [];
  displayedColumnAddressShipTo: any[] = [];
  displayedColumnPaymentTerms: any[] = [];
  //address1: BPMasterModelSAP1;

  canAdd: boolean = true;
  canEdit: boolean = true;
  canView: boolean = true;
  isActiveMenu: boolean = true;

  checkMenuPermissions() {
    let securityService = new SecurityService();
    let permissions = securityService.getMenuPermissions(this.getFormTitle);
    this.canAdd = permissions.canAdd;
    this.canEdit = permissions.canEdit;
    this.canView = permissions.canView;
    this.isActiveMenu = permissions.isActive;
  }

  auser: any; //objType: any;
  activeTab = 0; currentTabIndex = 0;
  indexCP = 0; indexAddress = 0; indexBank = 0;
  selectedType: any;
  selected: any;
  isAsDefault: boolean = false;
  isContactActive: boolean = false;
  isBoolCopyToShipToAddressChecked: boolean = false;
  public enumObjType = enumObjectType;
  isLinear = false;
  ReadMore: boolean = true
  visible: boolean = false
  isBpType: string = "customer"
  getFullAddress: any;
  editedAddress: any;
  bplid: any;
  ArrayofSelectedFile = new Array<string>();
  selectedFile: any[] = [];
  selectedAttacment: any[] = [];
  @Input() address: any; // The address details to edit
  @Output() addressSaved = new EventEmitter<any>();

  //addressType = [{ "code": "bo_BillTo", "type": "Bill To" }, { "code": "bo_ShipTo", "type": "Ship To" }];
  phoneMaskCharacters = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  genAttachUpload = new GenericAttachmentUploadView<IBPMasterModel>(this.http);
  constructor(agenericRepository: GenericService<IBPMasterModel>, private activatedRoute: ActivatedRoute, router: Router,
    public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<IBPMasterModel>>,
    public agenericRepositoryForCfl: GenericService<IBPMasterModel>, private http: HttpClient,
    public routerForCfl: Router, dialog: MatDialog,
      private ngxUiLoaderService: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    public matDialogforCfl: MatDialog,
    private dbService: NgxIndexedDBService) {

    super(agenericRepository, router, dialog);

    //this.setObjectType = this.activatedRoute.snapshot.data['ObjType'];
    this.setObjectType = this.activatedRoute.snapshot.data['ObjType'];

    this.setMenuCode = "M311";

    if (this.getObjectType == enumObjectType.Customer) {
      this.setFormTitle = 'Customer Master';
      this.setFormSubTitle = 'Customer Details';
      this.setListViewFormRouteTo = "/home/settings/bpmasterlist/";
      this.isBpType = "customer";

    }
    else if (this.getObjectType == enumObjectType.Vendor) {
      this.setFormTitle = 'Vendor Master';
      this.setFormSubTitle = 'Vendor Details';
      this.setListViewFormRouteTo = "/home/settings/vendormasterlist/";
      this.isBpType = "vendor";

    }
    else if (this.getObjectType == enumObjectType.Lead) {
      this.setFormTitle = 'Lead Master';
      this.setFormSubTitle = 'Lead Details';
      this.setListViewFormRouteTo = "/home/settings/leadmasterlist/";
      this.isBpType = "lead";

    }

    this.checkMenuPermissions();

    // this.setFormTitle = this.getObjectType == enumObjectType.Customer ? 'Add Customer' : this.getObjectType == enumObjectType.Vendor ? 'Add Vendor' : 'Add Lead';
    // this.setFormSubTitle = this.getObjectType == enumObjectType.Customer ? 'Customer Details' : this.getObjectType == enumObjectType.Vendor ? 'Vendor Details' : 'Lead Details';
    // this.setListViewFormRouteTo = this.getObjectType == enumObjectType.Customer ? "/home/settings/bpmasterlist/" : this.getObjectType == enumObjectType.Vendor ? "/home/settings/vendormasterlist/" : "/home/settings/leadmasterlist/";
    this.setRequestDataForFormModeNew = "";
    this.setURLForFormModeNew = "BusinessPartner/NewBusinessPartnerService";
    this.setURLForFormModeEdit = "BusinessPartner/GetBusinessPartnerService";
    this.setURLForFormModeAddSap = "BusinessPartners";
    this.setURLForFormModeUpdateSap = `BusinessPartners('${this.activatedRoute.snapshot.params['id']}')`;
    this.displayedColumns = ["contactPersonId", "contactPersonTitle", "firstName", "lastName", "email", "telephone1", "mobilephone", "position", "active", "del"]
    this.displayedColumnAddressBillTo = ["addressName", "deleteBillto"]
    this.displayedColumnAddressShipTo = ["addressName", "deleteShipto"]
    this.displayedColumnPaymentTerms = ["bankName", "accountName", "countryName", "accountNo", "bicSwiftCode", "delete"]



    let customer = new BPMasterModel();
    let customerSAP = new BPMasterModelSAP();
    customer.cardCode = this.activatedRoute.snapshot.params['id'] != 0 ? this.activatedRoute.snapshot.params['id'] : "";
    this.setEntryFormDataSource = customer;
    this.setEntryFormDataSourceSAP = customerSAP;

    let BPContactEmployee = new BPContactEmployeesModel();
    customer.contactEmployees.push(BPContactEmployee);

    // let BPAddress = new BPAddressesModel();
    // customer.bpAddresses.push(BPAddress);

    let BpBankAccounts = new BPBankAccountsModel();
    customer.bpBankAccounts.push(BpBankAccounts);

    let TaxIdPANNo = new BPFiscalTaxIDCollectionModel();
    customer.bpFiscalTaxIDCollection.push(TaxIdPANNo);

    let holdTaxCollection = new BPWithholdingTaxCollectionModel()
    customer.bpWithholdingTaxCollection.push(holdTaxCollection);

    let branchAssignment = new BPBranchAssignmentModel();
    customer.bpBranchAssignment.push(branchAssignment);

    if (customer.cardCode.toString().length > 0) {
      this.setRequestDataForFormModeEdit = customer.cardCode;
      this.setFormMode = enumFormModes.ModeEdit;
      this.setFormDisable = true;
    }
    else {
      this.setFormMode = enumFormModes.ModeNew;
    }
    this.PopulateEntryForm_V2();
  }
  async PopulateEntryForm_V2() {
    await this.PopulateEntryForm();
    console.log("address",this.getEntryFormDataSource);
    if (!this.getEntryFormDataSource.bpFiscalTaxIDCollection.length) {
      this.setEntryFormDataSource = {
        ...this.getEntryFormDataSource,
        bpFiscalTaxIDCollection: [{ taxId0: '' ,bpCode:''}]
      };
    }
    await this.genAttachUpload.onAttachmentGetFiles(this.getEntryFormDataSource.attachmentEntry);
    this.getEntryFormDataSource.Attachments2_Lines = this.genAttachUpload.getAttactmentListData;
    if (this.activatedRoute.snapshot.params['id'] == 0) {
      this.getEntryFormDataSource.bpAddresses = new Array();
    }
  }
  ngOnInit() {
    // this.getEntryFormDataSource.bpAddresses = { ...this.address };
   
  }

  //tab
  public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
    this.currentTabIndex = tabChangeEvent.index;
  }
  //CFL *************************************
  selectedData: any;
  onOpenDropDown(value: any, index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
  
    let genCFL = new GenericCflViewComponent<IBPMasterModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    if (value == 'group') {

     
      if(this.getFormSubTitle=="Customer Details" || this.getFormSubTitle=="Lead Details"){
      genCFL.setCflTitle = "Customer Group";
      genCFL.setCflViewDataSourceURL = 'CustomerGroup/GetCustomerGroupListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.groupName;//this.selectedData;
      genCFL.setSortColumn = "name";}
      else if(this.getFormSubTitle=="Vendor Details"){
        genCFL.setCflTitle = "Vendor Group";
        genCFL.setCflViewDataSourceURL = "VendorGroups/GetVendorGroupsListService";
        genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
        genCFL.setCflSelectedData = this.getEntryFormDataSource.groupName;//this.selectedData;
        genCFL.setSortColumn = "name";
      }
    }
    if (value == 'currency') {
      genCFL.setCflTitle = "Currencies";
      genCFL.setCflViewDataSourceURL = 'CurrenciesSetUp/GetCurrenciesSetUpListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.currencyName;//this.selectedData;
      genCFL.setSortColumn = "name";
    }
    if (value == 'pricelist') {
      genCFL.setCflTitle = "Price List";
      genCFL.setCflViewDataSourceURL = 'PriceList/GetPriceListListService';
      genCFL.setCflDisplayedColumnsNamesList = ['priceListNo', 'priceListName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.priceListName;//this.selectedData;
      genCFL.setSortColumn = "priceListName";
    }
    // if (value == 'country') {
    //   genCFL.setCflTitle = "Country";
    //   genCFL.setCflViewDataSourceURL = 'Country/GetCountryListService';
    //   genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
    //  genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[this.indexAddress].country;
    //   genCFL.setSortColumn = "name";
    // }



    // if (value == 'state') {
    //   if (this.getEntryFormDataSource.bpAddresses.length > 0) {
    //     genCFL.setCflTitle = "States";
    //     genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
    //     genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
    //     genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[this.indexAddress].state;//this.selectedData;
    //     genCFL.setSortColumn = "name";

    //     filter.Key = 'country';
    //     filter.OperatorType = "contains";
    //     filter.Value = this.getEntryFormDataSource.bpAddresses[this.indexAddress].country;
    //     genCFL.setCflFilterArray = filter;

    //   }
    // }
    // if (value == 'state') {
    //     genCFL.setCflTitle = "States";
    //     genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
    //     genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
    //     genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[this.indexAddress].state;//this.selectedData;
    //     genCFL.setSortColumn = "name";
    //     filter.Key = 'country';
    //     filter.OperatorType = "contains";
    //     filter.Value = this.getEntryFormDataSource.bpAddresses[this.indexAddress].country;
    //     genCFL.setCflFilterArray = filter;


    // }
    if (value == 'country') {
      genCFL.setCflTitle = "Country";
      genCFL.setCflViewDataSourceURL = 'Country/GetCountryListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[index].countryName;
      genCFL.setSortColumn = "name";
    }

    // if (value == 'state') {
    //   genCFL.setCflTitle = "State";
    //   genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
    //   genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
    //   genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[this.indexAddress].stateName;
    //   genCFL.setSortColumn = "name";

    //   filter.Key = 'country';
    //   filter.OperatorType = "contains";
    //   filter.Value = this.getEntryFormDataSource.bpAddresses[this.indexAddress].countryName;
    //   genCFL.setCflFilterArray = filter;
    // }
    if (value == 'state') {
      genCFL.setCflTitle = "State";
      genCFL.setCflViewDataSourceURL = 'State/GetStateListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[index].stateName;
      genCFL.setSortColumn = "name";
      filter.Key = 'country';
      filter.OperatorType = "contains";
      filter.Value = this.getEntryFormDataSource.bpAddresses[this.indexAddress].country;
      genCFL.setCflFilterArray = filter;

    }

    if (value == 'paymentterms') {
      genCFL.setCflTitle = "Payment Terms";
      genCFL.setCflViewDataSourceURL = 'PaymentTerms/GetPaymentTermsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['groupNumber', 'paymentTermsGroupName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.payTermsGrpCodeName;//this.selectedData;
      genCFL.setSortColumn = "paymentTermsGroupName";
    }
    if (value == 'bank') {
      genCFL.setCflTitle = "Bank";
      genCFL.setCflViewDataSourceURL = 'Banks/GetBanksListService';
      genCFL.setCflDisplayedColumnsNamesList = ['bankCode', 'bankName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpBankAccounts[index].bankName;//this.selectedData;
      genCFL.setSortColumn = "bankName";
    }
    if (value == 'wtaxcode') {
      genCFL.setCflTitle = "TDS/TCS Code";
      genCFL.setIsCflSingleSelection = false;
      genCFL.setCflViewDataSourceURL = 'WithholdingTaxCodes/GetWithholdingTaxCodesListService';
      genCFL.setCflDisplayedColumnsNamesList = ['wtCode', 'wtName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpWithholdingTaxCollection; //this.selectedData;
      genCFL.setSortColumn = "wtCode";
    }

    // if (value == 'wtaxcode') {
    //   if (this.getEntryFormDataSource.typeReport.length > 0) {
    //     genCFL.setCflTitle = "TDS/TCS Code";
    //    // genCFL.setIsCflSingleSelection = false;
    //     genCFL.setCflViewDataSourceURL = 'WithholdingTaxCodes/GetWithholdingTaxCodesListService';
    //     genCFL.setCflDisplayedColumnsNamesList = ['wtCode', 'wtName'];
    //     genCFL.setCflSelectedData = this.getEntryFormDataSource.wtCode; //this.selectedData;
    //     genCFL.setSortColumn = "wtCode";
    //     filter.Key = 'assessee';
    //     filter.OperatorType = ">=";
    //     filter.Value = this.getEntryFormDataSource.typeReport == enumBPMaster.Customer ? "1" : "2";
    //     genCFL.setCflFilterArray = filter;
    //     filter = new WrapperStandardFilter();
    //     filter.Key = 'assessee';
    //     filter.OperatorType = "<=";
    //     filter.Value = this.getEntryFormDataSource.typeReport == enumBPMaster.Customer ? "1" : "2";
    //     genCFL.setCflFilterArray = filter;
    //   }
    // }



    // if (value == 'wtaxcode') {
    //   if (this.getEntryFormDataSource.typeReport.length > 0) {
    //     genCFL.setCflTitle = "WTax";
    //     genCFL.setIsCflSingleSelection = false;
    //     genCFL.setCflViewDataSourceURL = 'WithholdingTaxCodes/GetWithholdingTaxCodesListService';
    //     genCFL.setCflDisplayedColumnsNamesList = ['wtCode', 'wtName'];
    //     genCFL.setCflSelectedData = this.getEntryFormDataSource.wtCode; //this.selectedData;
    //     genCFL.setSortColumn = "wtCode";

    //     filter.Key = 'assessee';
    //     filter.OperatorType = ">=";
    //     filter.Value = this.getEntryFormDataSource.typeReport == enumBPMaster.Customer ? "1" : "2";
    //     genCFL.setCflFilterArray = filter;
    //     filter = new WrapperStandardFilter();
    //     filter.Key = 'assessee';
    //     filter.OperatorType = "<=";
    //     filter.Value = this.getEntryFormDataSource.typeReport == enumBPMaster.Customer ? "1" : "2";
    //     genCFL.setCflFilterArray = filter;

    //   }
    // }

    if (value == 'connectedvendor') {

      if(this.getFormSubTitle=="Vendor Details"){
        
        genCFL.setCflTitle = "Vendor Details";
      }
      else if(this.getFormSubTitle=="Customer Details"){
        
        genCFL.setCflTitle = "Customer Details";
      }
      else if(this.getFormSubTitle=="Lead Details"){
        
        genCFL.setCflTitle = "Lead Details";
      }
      
    
      genCFL.setCflViewDataSourceURL = 'BusinessPartner/GetBusinessPartnerListService';
      genCFL.setCflDisplayedColumnsNamesList = ['cardCode', 'cardName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.linkedBusinessPartnerName;//this.selectedData;
      genCFL.setSortColumn = "cardName";
      filter.Key = 'CardType';
      filter.OperatorType = "contains";
     
      filter.Value = this.getObjectType == enumObjectType.Customer ? enumBPMaster.Customer : this.getObjectType == enumObjectType.Vendor ? enumBPMaster.Vendor : enumBPMaster.Lead;
      genCFL.setFilterArray = filter;
    }
    if (value == 'bptype') {
      genCFL.setCflTitle = "Business Partner Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'BPForm';
      genCFL.setCflEnumDataToStoreInDB = this.getEntryFormDataSource.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'businessPartnerType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = "value";
      genCFL.setCflSelectedData = this.getEntryFormDataSource.businessTypeName;
    }
    if (value == 'gsttype') {
      genCFL.setCflTitle = "GST Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'BPForm';
      genCFL.setCflEnumDataToStoreInDB = this.getEntryFormDataSource.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'gstType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = "value";
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpAddresses[index].gstTypeName;
    }
    if
      (value == 'assesseetype') {
      genCFL.setCflTitle = "Assessee Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'BPForm';
      genCFL.setCflEnumDataToStoreInDB = this.getEntryFormDataSource.enumData;
      genCFL.setCflEnumObjectNameToDisplay = 'assesseeType';
      genCFL.setCflDisplayedColumnsNamesList = ['description'];
      genCFL.setSortColumn = "value";
      genCFL.setCflSelectedData = this.getEntryFormDataSource.typeReportName;
    }
    if (value == 'salesPerson') {
      genCFL.setCflTitle = "Sales Employee";
      genCFL.setCflViewDataSourceURL = 'SalesEmployee/GetSalesEmployeeListService';
      genCFL.setCflDisplayedColumnsNamesList = ['salesEmployeeCode', 'salesEmployeeName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.slpName;
      genCFL.setSortColumn = "salesEmployeeName";
    }
    if (value == 'banks') {
      genCFL.setCflTitle = "Banks Details";
      genCFL.setCflViewDataSourceURL = 'Banks/GetBanksListService';
      genCFL.setCflDisplayedColumnsNamesList = ['bankCode', 'bankName', 'countryName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpBankAccounts[index].bankCode
      genCFL.setSortColumn = "bankCode";
    }
    if(value=='accounts') {
      
      genCFL.setCflTitle = "Accounts Details";
      genCFL.setCflViewDataSourceURL = 'Banks/GetBankAccountList';
      genCFL.setCflDisplayedColumnsNamesList = ['accountNumber', 'accountName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpBankAccounts[index].bankCode
      genCFL.setSortColumn = "bankCode";
      genCFL.setCFLRequestDataWithCode = this.getEntryFormDataSource.bpBankAccounts[index].bankCode;
      // let  data:WrapperStandardRequest<any> =new WrapperStandardRequest<any>();
      // data.RequestData=this.getEntryFormDataSource.bpBankAccounts[index].bankCode;
      // genCFL.setRequestData =  data;
      // filter.Key = 'type';
      // filter.OperatorType = null;
      // filter.Value = this.getEntryFormDataSource.activityType.toString();
      // genCFL.setCflFilterArray = filter;
    }
    if (value == 'branch') {
      genCFL.setCflTitle = "Branch";
      genCFL.setIsCflSingleSelection = false;
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
      genCFL.setCflDisplayedColumnsNamesList = ['branchName',];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bpBranchAssignment;
      genCFL.setSortColumn = "bplid";
      
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
    }

    genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
      if (res != undefined && res.event != undefined) {
        if (this.btnText == 'Language.OkText') {
          this.btnText = 'Language.UpdateText';
        }
        this.selectedData = res.event;
        if (value == 'group') {
          //this.selectedData = res.event.code;
          this.getEntryFormDataSource.groupCode = res.event.code;
          this.getEntryFormDataSource.groupName = res.event.name;
        }
        if (value == 'currency') {
          //this.selectedData = res.event.code;
          this.getEntryFormDataSource.currency = res.event.code;
          this.getEntryFormDataSource.currencyName = res.event.name;
        }
        if (value == 'state') {
          //this.selectedData = res.event.code;
          this.getEntryFormDataSource.bpAddresses[index].state = res.event.code;
          this.getEntryFormDataSource.bpAddresses[index].stateName = res.event.name;
        }
        if (value == 'country') {
          //this.selectedData = res.event.code;
          this.getEntryFormDataSource.bpAddresses[index].country = res.event.code;
          this.getEntryFormDataSource.bpAddresses[index].countryName = res.event.name;
        }
        if (value == 'paymentterms') {
          //this.selectedData = res.event.groupNumber;
          this.getEntryFormDataSource.payTermsGrpCode = res.event.groupNumber
          this.getEntryFormDataSource.payTermsGrpCodeName = res.event.paymentTermsGroupName
        }
        if (value == 'bank') {
          //this.selectedData = res.event.bankCode;
          this.getEntryFormDataSource.bpBankAccounts[index].bankCode = res.event.bankCode;
          this.getEntryFormDataSource.bpBankAccounts[index].bankName = res.event.bankName;
        }
        if(value=="accounts"){
          this.getEntryFormDataSource.bpBankAccounts[index].accountNo = res.event.accountNumber;
          this.getEntryFormDataSource.bpBankAccounts[index].accountName = res.event.accountName;
        }

        if (value == 'wtaxcode') {
          this.getEntryFormDataSource.bpWithholdingTaxCollection = [];
          for (let i = 0; i < res.event.length; i++) {
            let _wtaxCode = new BPWithholdingTaxCollectionModel();
            _wtaxCode.wtCode = res.event[i].wtCode;
            _wtaxCode.cardCode = this.getEntryFormDataSource.cardCode;
            this.getEntryFormDataSource.bpWithholdingTaxCollection.push(_wtaxCode);
          }

        }

        // if (value == 'wtaxcode') {
        //   let str = '';
        //   let strCode = '';
        //   res.event.forEach((element: any) => {
        //     this.getEntryFormDataSource.bpWithholdingTaxCollection.push({ 'wtCode': element.wtCode, 'bpCode': element.bpCode });
        //     str = str == '' ? element.wtName : str + ',' + element.wtName
        //     strCode = strCode == '' ? element.wtCode : strCode + ',' + element.wtCode
        //   });

        //   this.getEntryFormDataSource.wtCodeName = str;
        //   this.getEntryFormDataSource.wtCode = strCode;
        //   //this.selectedData = str;

        //   // if (value == 'branch') {
        //   //   this.getEntryFormDataSource.userBranchAssignment = [];
        //   //   for (let i = 0; i < res.event.length; i++) {
        //   //     let _BranchAss = new userBranchAssignment();
        //   //     // _BranchAss.employeeID = this.getEntryFormDataSource.employeeID
        //   //     _BranchAss.bplid = res.event[i].bplid;
        //   //     _BranchAss.userCode = this.getEntryFormDataSource.userCode;
        //   //     this.getEntryFormDataSource.userBranchAssignment.push(_BranchAss);
        //   //   }
        //   //   // for (let i = 0; i < res.event.length; i++) {
        //   //   //   let _BranchAss = new employeeBranchAssignment();
        //   //   //   // _BranchAss.employeeID = this.getEntryFormDataSource.employeeID
        //   //   //   _BranchAss.bplid =res.event[i].bplid;
        //   //   //   this.getEntryFormDataSource.employeeBranchAssignment.push(_BranchAss);
        //   //   // }
        //   // }


        // }
        if (value == 'connectedvendor') {
          //this.selectedData = res.event.cardCode;
          this.getEntryFormDataSource.linkedBusinessPartner = res.event.cardCode;
          this.getEntryFormDataSource.linkedBusinessPartnerName = res.event.cardName;
          this.getEntryFormDataSource.cardCode = res.event.cardCode;
          this.getEntryFormDataSource.cardName = res.event.cardName;
        }
        if (value == 'bptype') {

          this.getEntryFormDataSource.businessType = res.event.value;
          this.getEntryFormDataSource.businessTypeName = res.event.description;
        }
        if (value == 'gsttype') {
          this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstType = res.event.value;
          this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstTypeName = res.event.description;
        }
        if (value == 'assesseetype') {
          this.getEntryFormDataSource.typeReport = res.event.value;
          this.getEntryFormDataSource.typeReportName = res.event.description;
        }
        if (value == 'pricelist') {
          this.getEntryFormDataSource.priceListNum = res.event.priceListNo;
          this.getEntryFormDataSource.priceListName = res.event.priceListName;
        }
        if (value == 'salesPerson') {

          this.getEntryFormDataSource.slpCode = res.event.salesEmployeeCode
          this.getEntryFormDataSource.slpName = res.event.salesEmployeeName
        }
        if (value == 'branch') {
          this.getEntryFormDataSource.bpBranchAssignment = [];
          for (let i = 0; i < res.event.length; i++) {
            let _BranchAss = new BPBranchAssignmentModel();
            _BranchAss.bplid = res.event[i].bplid;
            this.getEntryFormDataSource.bpBranchAssignment.push(_BranchAss);
          }
        }

        if (value == 'banks') {
          this.getEntryFormDataSource.bpBankAccounts[index].bankCode = res.event.bankCode;
          this.getEntryFormDataSource.bpBankAccounts[index].bankName = res.event.bankName;
          this.getEntryFormDataSource.bpBankAccounts[index].country = res.event.countryCode;
          this.getEntryFormDataSource.bpBankAccounts[index].countryName = res.event.countryName;
          this.getEntryFormDataSource.bpBankAccounts[index].bicSwiftCode = res.event.swiftNo;
        }

      }
    })
  }
  //GENERAL *************************************
  onChangeRadio(val: MatRadioChange) {//valid/frozen
   
    if (val.value == 'active') {
      this.getEntryFormDataSource.valid = 'Y';
      this.getEntryFormDataSource.frozen = 'N';
    } else if (val.value == 'inactive') {
      this.getEntryFormDataSource.valid = 'N';
      this.getEntryFormDataSource.frozen = 'Y';
    }
  }
  onBusinessPartnerTypeChange() {
    this.getEntryFormDataSource.businessType = this.selected.code;
    this.getEntryFormDataSource.businessTypeName = this.selected.name;
  }
  //CONTACT PERSON *************************************
  onChangeContactActiveCheckBox(val: any, i :number) {
    if (val.checked) {
      this.getEntryFormDataSource.contactEmployees[i].active = "Y";
    } else {
      this.getEntryFormDataSource.contactEmployees[i].active = "N";
    }
  }
  onEditContactPerson(item: any, i: number) {
    this.indexCP = i;
  }

  // onAddNewContactPerson() {

  //   let ContactPerson = new BPContactEmployeesModel();

  //   if (this.getEntryFormDataSource.contactEmployees != null) {
  //     this.getEntryFormDataSource.contactEmployees.push(ContactPerson);
  //     this.getEntryFormDataSource.contactEmployees = [...this.getEntryFormDataSource.contactEmployees];

  //   }
  //   else {
  //     let contactList: BPContactEmployeesModel[] = [];
  //     contactList.push(ContactPerson);
  //     this.getEntryFormDataSource.contactEmployees = contactList;
  //   }

  //   this.indexCP = this.getEntryFormDataSource.contactEmployees.length - 1;

  // }
  onAddNewContactPerson(aEvent: any) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    let ContactPerson = new BPContactEmployeesModel();


    this.getEntryFormDataSource.contactEmployees.push(ContactPerson);
    this.getEntryFormDataSource.contactEmployees = [...this.getEntryFormDataSource.contactEmployees];
  }




  // addRow() {
  //   if (this.btnText == 'Language.OkText') {
  //     this.btnText = 'Language.UpdateText';
  //   }
  //   let lineItem = new InventoryCountingLinesModel();
  //   this.getEntryFormDataSource.inventoryCountingLines.push(lineItem);
  //   this.getEntryFormDataSource.inventoryCountingLines = [...this.getEntryFormDataSource.inventoryCountingLines];
  // }



  deleteContactPersonRow(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }

    this.getEntryFormDataSource.contactEmployees.splice(index, 1);
    this.getEntryFormDataSource.contactEmployees = [...this.getEntryFormDataSource.contactEmployees];
    //this.indexAddress = this.getEntryFormDataSource.contactEmployees.length - 1;
  }


  onDeleteNewBank(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }

    this.getEntryFormDataSource.bpBankAccounts.splice(index, 1);
    this.getEntryFormDataSource.bpBankAccounts = [...this.getEntryFormDataSource.bpBankAccounts];
    //this.indexAddress = this.getEntryFormDataSource.contactEmployees.length - 1;
  }

  deleteAddressRow(index: number) {
    if ((this.getFormMode == 0 && !this.canAdd) || (this.getFormMode == 1 && !this.canEdit)) {
      return;
    }
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    this.getEntryFormDataSource.bpAddresses.splice(index, 1);
  }



  /*onSaveContactPerson() {
  }*/
  //ADDRESS *************************************
  onChangeSetAsDefaultCheckBox(val: any) {
    if (val.checked) {
      this.getEntryFormDataSource.bpAddresses[this.indexAddress].isAsDefault = true//"tYES";
    } else {
      this.getEntryFormDataSource.bpAddresses[this.indexAddress].isAsDefault = false;//"tNO";
    }
  }
  // onChangeSetAsHideShow(val: any) {
  //   if (val==this.getEntryFormDataSource.openDeliveryNotesBalance==null) {
  //     this.getEntryFormDataSource.openDeliveryNotesBalance.ReadMore = !this.getEntryFormDataSource.openDeliveryNotesBalance.ReadMore;
  //   } else {
  //     this.getEntryFormDataSource.openDeliveryNotesBalance.visible = !this.getEntryFormDataSource.openDeliveryNotesBalance.visible
  //   }
  // }


  onChangeCopyCheckBox(val: any) {
    if (val.checked) {
      this.getEntryFormDataSource.bpAddresses[this.indexAddress].isBoolCopyToShipToAddressChecked = true;//"tYES";
      let Address = new BPAddressesModel();
      Address.addressType = 'bo_ShipTo';
      Address.addressName = this.getEntryFormDataSource.bpAddresses[this.indexAddress].addressName;
      Address.country = this.getEntryFormDataSource.bpAddresses[this.indexAddress].country;
      Address.countryName = this.getEntryFormDataSource.bpAddresses[this.indexAddress].countryName;
      Address.street = this.getEntryFormDataSource.bpAddresses[this.indexAddress].street;
      Address.streetNo = this.getEntryFormDataSource.bpAddresses[this.indexAddress].streetNo;
      Address.city = this.getEntryFormDataSource.bpAddresses[this.indexAddress].city;
      Address.state = this.getEntryFormDataSource.bpAddresses[this.indexAddress].state;
      Address.stateName = this.getEntryFormDataSource.bpAddresses[this.indexAddress].stateName;
      Address.zipCode = this.getEntryFormDataSource.bpAddresses[this.indexAddress].zipCode;
      Address.gstType = this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstType;
      Address.gstTypeName = this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstTypeName;
      Address.gstin = this.getEntryFormDataSource.bpAddresses[this.indexAddress].gstin;
      Address.isAsDefault = this.getEntryFormDataSource.bpAddresses[this.indexAddress].isAsDefault;

      this.getEntryFormDataSource.bpAddresses.push(Address);

    } else {
      this.getEntryFormDataSource.bpAddresses[this.indexAddress].isBoolCopyToShipToAddressChecked = false;//"tNO";
      //this.getEntryFormDataSource.bpAddresses.splice(this.indexAddress+1,1);
    }
  }
  // onEditAddress(item: any, i: number) {
  //   this.indexAddress = i;
  // }
  /*onDeleteAddress(i: number) {
    this.getEntryFormDataSource.bpAddresses.splice(i, 1);
  }*/
  onAddressTypeChange(type: any) {
    this.getEntryFormDataSource.bpAddresses[this.indexAddress].addressType = type;
  }


  // onAddNewContactPerson() {

  //   let ContactPerson = new BPContactEmployeesModel();

  //   if (this.getEntryFormDataSource.contactEmployees != null) {
  //     this.getEntryFormDataSource.contactEmployees.push(ContactPerson);
  //     this.getEntryFormDataSource.contactEmployees = [...this.getEntryFormDataSource.contactEmployees];

  //   }
  //   else {
  //     let contactList: BPContactEmployeesModel[] = [];
  //     contactList.push(ContactPerson);
  //     this.getEntryFormDataSource.contactEmployees = contactList;
  //   }

  //   this.indexCP = this.getEntryFormDataSource.contactEmployees.length - 1;

  // }


  onAddNewAddress(aType: string) {
    let Address = new BPAddressesModel();
    Address.addressType = aType;
    if (this.getEntryFormDataSource.bpAddresses != null) {
      this.getEntryFormDataSource.bpAddresses.push(Address);
      this.getEntryFormDataSource.bpAddresses = [...this.getEntryFormDataSource.bpAddresses];
    }
    else {
      let contactList: BPAddressesModel[] = [];
      contactList.push(Address);
      this.getEntryFormDataSource.bpAddresses = contactList;
    }


    //this.indexAddress = this.getEntryFormDataSource.bpAddresses.length - 1;
  }

  onGSTTypeChange() { }
  /*onSaveAddress() {
  }*/
  //PAYMENT TERMS/BANK *************************************
  // onAddNewBank() {
  //   let BankAccount = new BPBankAccountsModel();
  //   this.getEntryFormDataSource.bpBankAccounts.push(BankAccount);
  //   this.indexBank = this.getEntryFormDataSource.bpBankAccounts.length - 1;
  // }

  onAddNewBank() {
    let BankAccount = new BPBankAccountsModel();

    this.getEntryFormDataSource.bpBankAccounts.push(BankAccount);
    this.getEntryFormDataSource.bpBankAccounts = [...this.getEntryFormDataSource.bpBankAccounts];


  }
  onEditBank(item: any, i: number) {
    this.indexBank = i;
  }
  /*onSaveBank() { }*/
  //ACCOUNTING *************************************
  onAssesseeTypeChange(val: any) {
    this.getEntryFormDataSource.typeReport = val;
  }
  onChangeAccontingRadio(val: any) {

  }
  onChangeSubjectToWithholdingTax(val: any) {
    if (val.checked) {
      this.getEntryFormDataSource.subjectToWithholdingTax = 'Y';
    } else {
      this.getEntryFormDataSource.subjectToWithholdingTax = 'N';
    }
  }

  //FINAL SAVE ********************************
  onValidate(): boolean {
    let lreturn: boolean = true;
    let value = [];
    let data: any = this.getEntryFormDataSource;

    data.cardCode == null || data.cardCode.length == 0 ? value.push(enumErrorMessageText.cardCodeStatus) : null;
    data.seriesName == null || data.seriesName.length == 0 ? value.push(enumErrorMessageText.seriesNameStatus) : null;
    data.docNum == null || data.docNum.length == 0 ? value.push(enumErrorMessageText.docNumStatus) : null;
    //data.documentLines[].itemCode == null ||data.documentLines[0].itemCode.length == 0 ? value.push(enumErrorMessageText.itemCodeStatus):null;
    data.branchName == null || data.branchName.length == 0 ? value.push(enumErrorMessageText.bplNameStatus) : null;
    data.cardName == null || data.cardName.length == 0 ? value.push(enumErrorMessageText.cardNameStatus) : null;
    data.groupName == null || data.groupName.length == 0 ? value.push(enumErrorMessageText.groupNameStatus) : null;
    data.currencyName == null || data.currencyName.length == 0 ? value.push(enumErrorMessageText.currencyNameStatus) : null;
    data.businessTypeName == null || data.businessTypeName.length == 0 ? value.push(enumErrorMessageText.businessTypeNameStatus) : null;
    //data.contactEmployees[this.indexCP].name == null || data.contactEmployees[this.indexCP].name.length == 0 ? value.push(enumErrorMessageText.contactEmployeesStatus) : null;
    data.bpAddresses == null || data.bpAddresses.length == 0 ? value.push(enumErrorMessageText.bpAddressesStatus) : null;
    //data.bpAddresses == 0 || data.bpAddresses == null ? value.push(enumErrorMessageText.bpAddressesStatus1) : null;
    data.countryName == null || data.CountryName.length == 0 ? value.push(enumErrorMessageText.CountryNameStatus) : null;
    data.stateNameStatus == null || data.stateNameStatus.length == 0 ? value.push(enumErrorMessageText.stateNameStatus) : null;
    data.gstTypeNameStatus == null || data.gstTypeNameStatus.length == 0 ? value.push(enumErrorMessageText.gstTypeNameStatus) : null;
    data.gstinStatus == null || data.gstinStatus.length == 0 ? value.push(enumErrorMessageText.gstinStatus) : null;
    data.payTermsGrpCodeName == null || data.payTermsGrpCodeName.length == 0 ? value.push(enumErrorMessageText.payTermsGrpCodeNameStatus) : null;
    //data.bpFiscalTaxIDCollection[0].taxId0 == null || data.bpFiscalTaxIDCollection[0].taxId0.length == 0 ? value.push(enumErrorMessageText.taxId0Status) : null;

    this.showValidationArr = value;
    this.title = this.getFormSubTitle;
    if (this.showValidationArr.length != 0) {
      lreturn = false
    }
    return lreturn
  }
  onSave(aEvent: any) {
    if (this.btnText == 'Language.OkText') {
      this.routerForCfl.navigate([this.getListViewFormRouteTo]);
    }
    else {
      if (!this.onValidate()) {

      // Object.assign(new BPAddressesModel(),this.getEntryFormDataSource.bpAddresses[0])
      //  createMap(mapper, BPAddressesModel , BPAddressesModelSAP);
         createMap(mapper, BPAddressesModel, BPAddressesModelSAP,
                    forMember(
                        (destination) => destination.AddressType,
                        mapFrom((source) => (source.addressType == 'bo_BillTo' ? 'bo_BillTo' : 'bo_ShipTo'))
                    ),
                    forMember(
                        (destination) => destination.AddressName,
                        mapFrom((source) => source.addressName)
                    ),
                    forMember(
                        (destination) => destination.Street,
                        mapFrom((source) => source.street)
                    ),
                    forMember(
                        (destination) => destination.Block,
                        mapFrom((source) => source.block)
                    ),
                    forMember(
                        (destination) => destination.ZipCode,
                        mapFrom((source) => source.zipCode)
                    ),
                    forMember(
                        (destination) => destination.City,
                        mapFrom((source) => source.city)
                    ),
                    forMember(
                        (destination) => destination.County,
                        mapFrom((source) => source.county)
                    ),
                    forMember(
                        (destination) => destination.Country,
                        mapFrom((source) => source.country)
                    ),
                    forMember(
                        (destination) => destination.State,
                        mapFrom((source) => source.state)
                    ),
                    forMember(
                        (destination) => destination.StreetNo,
                        mapFrom((source) => source.streetNo)
                    ),
                    forMember(
                        (destination) => destination.GstType,
                        mapFrom((source) => source.gstType)
                    ),
                    forMember(
                        (destination) => destination.GSTIN,
                        mapFrom((source) => source.gstin)
                    ),
                    forMember(
                        (destination) => destination.BPCode,
                        mapFrom((source) => source.cardCode)
                    ),
                    forMember(
                        (destination) => destination.RowNum,
                        mapFrom((source) => source.rowNum)
                    ));

        let dto = mapper.map(this.getEntryFormDataSource, BPMasterModel, BPMasterModelSAP);

       
        

        this.setObjectType = this.activatedRoute.snapshot.data['ObjType'];
        if (this.getObjectType == enumObjectType.Customer) {
          dto.CardType = 'cCustomer';
        }
        else if (this.getObjectType == enumObjectType.Vendor) {
          dto.CardType = 'cSupplier';
        }
        else if (this.getObjectType == enumObjectType.Lead) {
          dto.CardType = 'cLid'
        }
        this.getEntryFormDataSource.valid == 'Y' ? dto.Valid = 'tYES' : dto.Valid = 'tNO';
        this.getEntryFormDataSource.frozen == 'Y' ? dto.Frozen = 'tYES' : dto.Frozen = 'tNO';

        for (let i = 0; i < this.getEntryFormDataSource.contactEmployees.length; i++) {
          this.getEntryFormDataSource.contactEmployees[i].active == 'Y' ? dto.ContactEmployees[i].Active = 'tYES' : dto.Frozen = 'tNO';
        }
        //address - set as default
        //payment terms


        // this.getEntryFormDataSource.subjectToWithholdingTax == 'Y' ? dto.SubjectToWithholdingTax = 'boYES' : 'boNO';
        this.getEntryFormDataSource.subjectToWithholdingTax == 'Y' ? dto.SubjectToWithholdingTax = 'boYES' : 'boNO';
        if (this.getEntryFormDataSource.Attachments2_Lines.length > 0) {
          dto.AttachmentEntry = localStorage.getItem("Absolute") || this.getEntryFormDataSource.attachmentEntry;
          localStorage.removeItem('Absolute');
        }
    
   dto.BPFiscalTaxIDCollection= this.filterObject(dto).BPFiscalTaxIDCollection.filter((item:any)=> Object.keys(item).length != 0);
        this.setEntryFormDataSourceSAP = this.filterObject(dto);
        this.SaveEntryForm();
      }
      else {
        this.openDialog();
      }
    }
  }

  filterObject(obj: any): any {
    if (Array.isArray(obj)) {
      return obj
        .map(item => this.filterObject(item)) // Recursively filter each element
        .filter(item => item !== null && item !== undefined && item !== false && item !== ''); // Remove falsy elements
    } else if (typeof obj === "object" && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj)
          .map(([key, value]) => [key, this.filterObject(value)]) // Recursively filter nested objects
          .filter(([_, value]) => value !== null && value !== undefined && value !== false && value !== '') // Remove falsy properties
      );
    }
    return obj; // Return primitives as is
  }

  onSelectedFiles(event: any) {
    this.selectedFile.push(...Array.from(event.target.files))
    for (let i = 0; i < this.selectedFile.length; i++) {
      var _files = new Attachments2_LinesModel();
      _files.FileName = event.target.files[i].name;
      _files.FileExtension = event.target.files[i].name.split(".")[ event.target.files[i].name.split(".").length-1];
      this.getEntryFormDataSource.Attachments2_Lines.push(_files);
    }
    this.genAttachUpload.setSelectedFileList = {target: {files: this.selectedFile}};
    this.genAttachUpload.onSelectedFiles();
  }
  onUpload() {
    if(this.validateFileSize()) {
      this.genAttachUpload.onUploadFiles(this.getEntryFormDataSource.attachmentEntry);
    }else {
      this.openDialog();
    }
  }

  validateFileSize() {
    const maxFileSize = 5* 1024 * 1024; // 5 MB in bytes
    const files = this.selectedFile;
    let errors: string[] = [];

    if(files.length > 10) {
      errors.push('You can only upload a maximum of 10 files.');
    }else {  
      files.forEach((el, i): any => {
        let file: any = files[i];
        if(file.size > maxFileSize) {
          errors.push(`File "${file.name}" exceeds the 5 MB size limit.`);
        }
      })
    }

    if(errors.length > 0) {
      this.showValidationArr = errors;
      return false;
    }else {
      return true;
    }
  }

  onAttachmentDelete(val: number) {
    this.selectedFile.splice(val,1);
    this.getEntryFormDataSource.Attachments2_Lines.splice(val,1);
    this.getEntryFormDataSource.Attachments2_Lines=[...this.getEntryFormDataSource.Attachments2_Lines];
    if (this.getEntryFormDataSource.attachmentEntry != null && this.getEntryFormDataSource.attachmentEntry != "" && this.getEntryFormDataSource.attachmentEntry != undefined) {
      this.genAttachUpload.onAttachmentDeleteFiles(this.getEntryFormDataSource.attachmentEntry, this.getEntryFormDataSource.Attachments2_Lines)
    }
  }

  viewImage(attachmentEntry: number, filePath = "") {
   // window.open(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`, "_blank");
    this.ngxUiLoaderService.start(); 
      const url = `${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`;
      const companyID:any = sessionStorage.getItem("companyID");
        const token:any=sessionStorage.getItem('sapToken')
     fetch(url, {
         method: 'GET',
         headers: {
             Authorization: `Bearer ${JSON.parse(token)}` ,
            "x-b1-companyid": encodeURIComponent(companyID)
         }
     })
     .then(response => {
         if (!response.ok) {
             throw new Error("Failed to fetch attachment");
         }
         return response.blob();
     })
     .then(blob => {
         const blobUrl = URL.createObjectURL(blob);
         window.open(blobUrl, "_blank");
       this.ngxUiLoaderService.stop(); 
         // Optional: clean up the blob URL after some time
         setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
     })
     .catch(error => {
         console.error("Download error:", error);
     });
  }

  openAddressDialog(address: string, index: number = 0, action: string = 'add'): void {
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    let BPAddress = new BPAddressesModel();
    BPAddress.addressType = address;
    let filterDialogRef = this.dialog.open(AddAddressComponent, {
      data: {
        editedAddress: action == 'edit' ? this.getEntryFormDataSource.bpAddresses[index] : BPAddress,
        gstType: this.getEntryFormDataSource
      }
    });

    filterDialogRef.afterClosed().subscribe((res: any) => {

      if (res) {
        let BPAddress = new BPAddressesModel();
        BPAddress.addressType = address;
        BPAddress.addressType = address;
        BPAddress.addressName = res.addressName;
        BPAddress.countryName = res.countryName;
        BPAddress.stateName = res.stateName;
        BPAddress.state= res.state;
        BPAddress.street = res.street;
        BPAddress.streetNo = res.streetNo;
        BPAddress.city = res.city;
        BPAddress.zipCode = res.zipCode;
        BPAddress.country=res.country
        BPAddress.gstin = res.gstin;
        BPAddress.gstType = res.gstType;
        BPAddress.rowNum=res.rowNum;
        BPAddress.cardCode=res.cardCode;
       // BPAddress = { ...BPAddress };
        action == "add" ? this.getEntryFormDataSource.bpAddresses.push(BPAddress) : this.getEntryFormDataSource.bpAddresses[index] = BPAddress;
        if (res?.isBoolCopyToShipToAddressChecked) {
          BPAddress = { ...BPAddress };
          BPAddress.addressType = "bo_ShipTo";
          this.getEntryFormDataSource.bpAddresses.push(BPAddress);
        }
      }
    });


   // console.log(' this.getEntryFormDataSource.bpAddresses', this.getEntryFormDataSource.bpAddresses)
  }


  //    filteredItems(): any[] {
  //   return this.getEntryFormDataSource.bpAddresses.filter(item => item.addressType='bo_billTo');
  // }


  onEditAddressButton() {
    this.addressSaved.emit(this.editedAddress);

  }

  

  public getAddress(row: BPAddressesModel) {
    let result = new Array();
    row.street ? result.push(row.street) : false;
    row.streetNo ? result.push(row.streetNo) : false;
    row.city ? result.push(row.city) : false;
    row.zipCode ? result.push(row.zipCode) : false;
    row.stateName ? result.push(row.stateName) : false;
    row.countryName ? result.push(row.countryName) : false;
    return result.join(", ");
  }

}

